import { ReactNode } from 'react';
import Button from '@/components/Button';
import Confirm from '@/components/Confirm';
import { OrderIncompleteDeliveryReason } from '@/models/OrderIncompleteDelivery';
import ExportCurrentOrderButton from '@/modules/order/components/ExportCurrentOrderButton';
import type { Order } from '@/modules/order/models/Order';
import { OrderStatus as OrderStatusModel } from '@/modules/order/models/OrderStatus';
import { OrderListPath } from '@/modules/order/paths';
import ReportIncompleteDeliveryButton from '@/modules/store/pages/OrderDetails/ReportIncompleteDeliveryButton';

interface StoreOrderDetailsNavProps {
  order: Order;
  onReceiveOrder: () => Promise<void>;
  onReportIncompleteDelivery: (
    reason: OrderIncompleteDeliveryReason,
    comment?: string,
  ) => Promise<void>;
  hasReportedIncompleteDelivery: boolean;
  reorderAction?: ReactNode;
}

const StoreOrderDetailsNav = ({
  order,
  onReceiveOrder,
  onReportIncompleteDelivery,
  hasReportedIncompleteDelivery,
  reorderAction,
}: StoreOrderDetailsNavProps) => {
  return (
    <>
      {reorderAction}
      <Button data-testid="order-details-back-button" to={OrderListPath} variant="secondary">
        Back
      </Button>
      <ExportCurrentOrderButton orderId={order.id} />
      {order.status === OrderStatusModel.Dispatched && (
        <>
          <ReportIncompleteDeliveryButton
            onReportIncompleteDelivery={onReportIncompleteDelivery}
            reported={hasReportedIncompleteDelivery}
          />
          <Confirm
            onConfirm={onReceiveOrder}
            title="Receive Order"
            message={`Are you sure you want to update the status to received for order #${order.code}?`}
          >
            {(handleClick, loading) => (
              <Button
                data-testid="order-details-receive-button"
                onClick={handleClick}
                variant="primary"
                loading={loading}
              >
                Order Received
              </Button>
            )}
          </Confirm>
        </>
      )}
    </>
  );
};

export default StoreOrderDetailsNav;
